import {useEffect} from "react";
import {ReactiveVar} from "@apollo/client/cache/inmemory/reactiveVars";
import {useReactiveVar} from "@apollo/client";

export const useResult = ([fetcher, result], setResult) => {

  const fetch = (loading, error, data) => {
    if (!loading && data) {
      setResult(data[Object.keys(data)[0]])
    }
    if (error) {
      setResult(new Error(error))
      console.error(error)
    }
  }

  useEffect(() => {
    fetch(result.loading, result.error, result.data)
  }, [result.loading, result.error, result.data])

  return fetcher
}


export const useReactiveResult = <T>(reactiveVar: ReactiveVar<T>): [T, (P) => void] => {
  return [
    useReactiveVar<T>(reactiveVar), (p: T) => {
      reactiveVar(p)
    }]
}
